import React from "react";

let defaultValue: any = {
  provider: null,
  loadWeb3Modal: () => {},
  logoutOfWeb3Modal: () => {},
  signedInAddress: "",
  walletConnected: false
};
const Web3Context = React.createContext(defaultValue);

export default Web3Context;
